import { gql, useQuery } from '@apollo/client';
import { useCurrentMemberContext } from 'src/contexts';

export const SEARCH_IN_GANTT_PROJECTS_BY_CUSTOMERS = gql`
  query searchInGanttProjectsByCustomers($ganttId: String!, $searchValue: String) {
    searchInGanttProjectsByCustomers(ganttId: $ganttId, searchValue: $searchValue) {
      customer {
        _id
        name
      }
      projects {
        _id
        name
      }
    }
  }
`;

export const useSearchInGanttProjectsByCustomers = (searchValue?: string) => {
  const { ganttId } = useCurrentMemberContext();
  const { data, loading } = useQuery(SEARCH_IN_GANTT_PROJECTS_BY_CUSTOMERS, {
    variables: { ganttId, searchValue },
    fetchPolicy: 'network-only',
  });

  const projectsByCustomers = data?.searchInGanttProjectsByCustomers || [];

  return {
    loading,
    projectsByCustomers,
  };
};
